var map = {
	"./1.png": "2da5",
	"./2.png": "ab31",
	"./3.png": "088b",
	"./4.png": "9862",
	"./5.png": "fa7d",
	"./6.png": "f7f1",
	"./7.png": "6a78"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "86bf";